import { FC } from 'react'
import { SectionTermlyProps } from '@portfolio/models'
import { styled } from '@portfolio/styles'
import Script from 'next/script'

const TermlyEmbed = styled('div', {
  marginTop: '$96',
  minHeight: '100vh',
})

export const SectionTermly: FC<SectionTermlyProps> = ({ termlyId }) => {
  return (
    <>
      <Script
        src={'https://app.termly.io/embed-policy.min.js'}
        strategy="afterInteractive"
      />
      <TermlyEmbed
        //@ts-expect-error
        name="termly-embed"
        data-id={termlyId}
        data-type="iframe"
      />
    </>
  )
}
